import card from "@/components/models/Card.vue";
import _ from 'lodash';

let timerQueryModels, timerQueryModelsOnLoad;
const timeout = 1000;

export default {
  state: {
    filter: {
      search: "",
      page: 1,
      countModels: null,
      sort: "popular",

      view3d: false,
      viewAr: false,

      manufacturers: [],
      files: [],
      objects: [],
      aparts: [],
      materials: [],
      categories: null,
      types: null,
      classes: null,
      attributes: null,
      regions: [],
    },

    data: {
      manufacturers: [],
      files: [],
      objects: [],
      aparts: [],
      materials: [],
      categories: [],
      types: [],
      classes: [],
      regions: [],
      models: [],
      group: {},
    },

    contentLoaded: false,
    totalPages: 0,
    totalModels: 0,
    totalAllModels: 0,

    locationQuery: "",
    gridType: "small",
    counterFilterTags: null,
  },
  mutations: {
    //Полный список производителей
    getManufacturerList(state, manufacturers) {
      state.data.manufacturers = manufacturers;
    },

    //Полный список файлов
    getFileList(state, files) {
      state.data.files = files;
    },

    //Полный список объектов
    getObjectsType(state, objects) {
      state.data.objects = objects;
    },

    //Полный список помещений
    getAparts(state, aparts) {
      state.data.aparts = aparts;
    },

    //Полный список материалов
    getMaterials(state, materials) {
      state.data.materials = materials;
    },

    //Полный список категорий
    getCategory(state, categories) {
      state.data.categories = categories;
    },

    //Полный список типов
    getTypes(state, types) {
      state.data.types = types;
    },

    //Полный список типов
    getClasses(state, classes) {
      state.data.classes = classes;
    },

    // Список выбранных производителей (только id)
    manufacturersFilteres(state, manufacturers) {
      state.filter.manufacturers = [...manufacturers];
    },
    // Список выбранных файлов (только id)
    filesFilteres(state, files) {
      state.filter.files = [...files];
    },
    // Выбранная категория (только id)
    categoriesFilteres(state, categories) {
      state.filter.categories = categories;
    },
    // Выбранный тип (только id)
    typesFilteres(state, types) {
      state.filter.types = types;
    },
    // Выбранный тип (только id)
    classesFilteres(state, classes) {
      state.filter.classes = classes;
    },
    // Выбранный атрибут (только id)
    attributesFilteres(state, attributes) {
      state.filter.attributes = attributes;
    },
    // Выбранный атрибут (только id)
    countFilteres(state, count) {
      state.filter.countModels = count;
    },
    // Список выбранных объектов (только id)
    objectsFilteres(state, objects) {
      state.filter.objects = [...objects];
    },
    // Список выбранных помещений (только id)
    apartsFilteres(state, aparts) {
      state.filter.aparts = [...aparts];
    },
    // Список выбранных материалов (только id)
    materialsFilteres(state, materials) {
      state.filter.materials = [...materials];
    },
    // Изменение переключателя 3D
    view3dFilteres(state, val) {
      state.filter.view3d = val;
    },
    // Изменение переключателя AR
    viewArFilteres(state, val) {
      state.filter.viewAr = val;
    },
    // Изменение строки поиска
    searchFilteres(state, val) {
      state.filter.search = val;
    },
    // Изменение сортировки
    sortFilteres(state, val) {
      state.filter.sort = val;
    },

    // задает выбранную страницу
    setPage(state, page) {
      state.filter.page = page;
    },
    // Ставит флаг что страница с моделями загружена
    contentLoaded(state) {
      state.contentLoaded = true;
    },
    // Передаем query параметры
    setLocationQuery(state, params) {
      state.locationQuery = params;
    },
    // задаем тип сетки с карточками
    setGridType(state, type) {
      state.gridType = type;
    },

    resetFilter(state, type) {
      switch (type) {
        case "manufacturers":
          state.filter.manufacturers = [];
          break;
        case "files":
          state.filter.files = [];
          break;
        case "materials":
          state.filter.materials = [];
          break;
        case "objects":
          state.filter.objects = [];
          break;
        case "aparts":
          state.filter.aparts = [];
          break;
        case "preview":
          state.filter.view3d = false;
          state.filter.viewAr = false;
          break;
        case "category":
          state.filter.categories = null;
          state.filter.types = null;
          state.filter.classes = null;
          state.filter.attributes = null;
          break;
        case "all":
        default:
          state.filter = {
            search: "",
            page: 1,
            sort: "popular",

            view3d: false,
            viewAr: false,

            manufacturers: [],
            files: [],
            objects: [],
            aparts: [],
            materials: [],
            categories: null,
            types: null,
            classes: null,
            attributes: null,
            regions: [],
          };
          break;
      }
    },
    counterFilterTags(state, amount) {
      state.counterFilterTags = amount;
    },
    getTotalPages(state, count) {
      state.totalPages = count;
    },
    getTotalModels(state, count) {
      state.totalModels = count;
    },
    getTotalAllModels(state, count) {
      state.totalAllModels = count;
    },
    getModels(state, models) {
      state.data.models = models;
    },
    setGroupedModels(state, object) {
      state.data.group = object;
    },
  },
  actions: {
    /*
     * При загрузке страницы проверяет строку запроса на наличие query параметров.
     * Если они есть, то проставляет нужные крутилки в фильтре
     */
    async locationQueryOnLoad({ commit, dispatch }, group = false) {
      const params = await dispatch("checkQueryParams");
      // Проверяем пустой ли объект params
      if (!!params.toString()) {
        const iter = new Map(params.entries());
        const objectQuery = [...iter].reduce((obj, [key, value]) => {
          obj[key] = value;
          return obj;
        }, {});

        // Строка поиска
        if ("search" in objectQuery) commit("searchFilteres", objectQuery.search);

        if ("page" in objectQuery) commit("setPage", objectQuery.page);

        // Сортировка
        if ("sort" in objectQuery) commit("sortFilteres", objectQuery.sort);

        // Производители
        if ("manufacturers" in objectQuery) {
          // Если строка есть, то получаем весь список потому что вдруг выбран производитель не из первой пятерки
          await dispatch("getManufacturerData"); // лимит весь
          dispatch("arrayMarkChecked", {
            arrayName: "manufacturers",
            arrayIds: objectQuery.manufacturers.split(","),
          });
        } else await dispatch("getManufacturerData");

        // Файлы
        if ("files" in objectQuery) {
          await dispatch("getFilesData");
          dispatch("arrayMarkChecked", {
            arrayName: "files",
            arrayIds: objectQuery.files.split(","),
          });
        } else await dispatch("getFilesData");

        // Раздел
        await dispatch("getSectionData");
        if ("category" in objectQuery) dispatch("setCategories", objectQuery.category);

        // Категория
        if ("type" in objectQuery) dispatch("setTypes", objectQuery.type);

        // Подкатегория
        if ("class" in objectQuery) commit("classesFilteres", objectQuery.class);

        // Атрибут
        if ("attributes" in objectQuery) commit("attributesFilteres", objectQuery.attributes);

        // Объекты
        if ("objects" in objectQuery) {
          await dispatch("getObjectsTypesData");
          commit("objectsFilteres", objectQuery.objects.split(","));
          dispatch("arrayMarkChecked", {
            arrayName: "objects",
            arrayIds: objectQuery.objects.split(","),
          });
        } else await dispatch("getObjectsTypesData");

        // Помещения
        if ("aparts" in objectQuery) {
          await dispatch("getApartsData");
          dispatch("arrayMarkChecked", {
            arrayName: "aparts",
            arrayIds: objectQuery.aparts.split(","),
          });
        } else await dispatch("getApartsData");

        // Материалы
        if ("materials" in objectQuery) {
          await dispatch("getMaterialsData");
          dispatch("arrayMarkChecked", {
            arrayName: "materials",
            arrayIds: objectQuery.materials.split(","),
          });
        } else await dispatch("getMaterialsData");

        if ("regions" in objectQuery) {
          commit("getCheckedRegionsList", objectQuery.regions.split(","));
        }

        // 3d модели
        if ("view3d" in objectQuery) {
          commit("view3dFilteres", objectQuery.view3d);
        }

        // AR модели
        if ("viewAr" in objectQuery) {
          commit("viewArFilteres", objectQuery.viewAr);
        }

        // После применения всех фильтров запрашиваем модели по этим параметрам
        // return params
      } else {
        dispatch("getFirstData");
      }

      clearTimeout(timerQueryModels); // чистим таймаут, который возможно был вызван изменением селектов при их
      // рендере в функции setQueryParams
      commit("setLocationQuery", params);

      timerQueryModels = setTimeout(() => {
        // console.log('Рендер моделей при загрузке страницы.')
        dispatch("renderModels");
      }, timeout);
    },

    /**
     * Прописывает параметры в строку запроса браузера.
     * @param {string} nameQuery - название query параметра
     * @param {array} arr - массив параметров, которые нужно занести в URL. Если в массив первым значением передан
     *   false, тогда происходит удаление этого параметра из адресной стркои
     * @param {boolean} dontCheckContentLoad - не проверять на загрузку контента
     */
    setQueryParams(
      { state, commit, dispatch },
      { nameQuery, arr = [], dontCheckContentLoad = false }
    ) {
      if (state.contentLoaded || dontCheckContentLoad) {
        clearTimeout(timerQueryModels);

        const params = new URLSearchParams(location.search); // создаем конструктор для работы со строкой гет запросов
        arr.length && arr[0]
          ? params.set(nameQuery, arr.join(",")) // если в массиве есть чекнутые значения, то добавляем/обновляем строку
          : params.delete(nameQuery); // если нет, тогда полностью удаляем текущую позицию из гет запроса

        const iter = new Map(params.entries()); // создаем итератор из вписанных значений, преобразовываем его в Map
        // массив (подробнее тут: https://learn.javascript.ru/map-set)

        iter.size // проверяем размер итератора (возвращает number)
          ? window.history.replaceState({}, "", `${location.pathname}?${params}`) // если значения есть, тогда
          : // работаем дальше
            window.history.replaceState({}, "", `${location.pathname}`); // если нет, тогда вытираем строку get
        // debugger
        commit("setLocationQuery", params);
        if (nameQuery !== "page" && state.filter.page !== 1) {
          dispatch("setPage", 1);
        } else {
          timerQueryModels = setTimeout(() => {
            // console.log('Рендер моделей. Последний запрос:', nameQuery)
            dispatch("renderModels");
          }, timeout);
        }
      }
    },

    /**
     * Проверка наличия query параметров
     */
    checkQueryParams({ commit }) {
      const params = new URLSearchParams(location.search);
      commit("setLocationQuery", params);
      return params;
    },

    /**
     * Сброс строки параметров
     */
    resetQueryParams() {
      window.history.pushState({}, document.title, "/models/");
    },

    /**
     * Функция выбора чекбоксов. Парсит массив из стейта.
     * @param state
     * @param commit
     * @param dispatch
     * @param {string} stateNameArr - название массива в state
     */
    toggleCheckbox({ state, commit, dispatch }, stateNameArr) {
      let checkedArrId;
      if (stateNameArr === "viewAr" || stateNameArr === "view3d") {
        state.filter[stateNameArr] = !state.filter[stateNameArr];
        checkedArrId = state.filter[stateNameArr];
      } else {
        checkedArrId = state.data[stateNameArr]
          .map((el) => (el.checked ? el.id : null))
          .filter((el) => el);
      }

      dispatch("setQueryParams", {
        nameQuery: stateNameArr,
        arr: Array.isArray(checkedArrId) ? checkedArrId : [checkedArrId],
      });
      commit(`${stateNameArr}Filteres`, checkedArrId);
    },

    /**
     * Перелистывает на полученную страницу
     * @param commit
     * @param dispatch
     * @param page {number} - номер страницы
     */
    setPage({ commit, dispatch }, page) {
      commit("setPage", page);
      dispatch("setQueryParams", { nameQuery: "page", arr: page !== 1 ? [page] : [] });
    },
    /**
     * Проставляет параметр checked = true для массивов arrayName по переданным id arrayIds. Работает только когда
     * загружается страница
     * @param state
     * @param commit
     * @param arrayName {string} - название массива, в котором нужно проставить поля
     * @param arrayIds {array} - массив ID, которые чекнуты
     */
    arrayMarkChecked({ state, commit }, { arrayName, arrayIds }) {
      state.data[arrayName].forEach((el) => {
        arrayIds.forEach((id) => {
          if (id === el.id) {
            el.checked = true;
          }
        });
      });
      commit(`${arrayName}Filteres`, arrayIds);
    },

    setCategories({ state, commit, dispatch }, id) {
      state.filter.classes = "";
      state.filter.types = "";
      commit("categoriesFilteres", id);
      dispatch("getTypeFromStore", id);
      dispatch("setQueryParams", { nameQuery: "category", arr: [id] });
    },
    setTypes({ state, commit, dispatch }, id) {
      state.filter.classes = "";
      commit("typesFilteres", id);
      dispatch("getClassFromStore", id);
      dispatch("setQueryParams", { nameQuery: "type", arr: [id] });
    },
    setClasses({ state, commit, dispatch }, id) {
      commit("classesFilteres", id);
      dispatch("setQueryParams", { nameQuery: "class", arr: [id] });
    },
    setSort({ commit, dispatch }, val) {
      commit("sortFilteres", val);
      dispatch("setQueryParams", { nameQuery: "sort", arr: [val] });
    },
    // setSearch ({commit}, search) {
    //   commit('searchFilteres', search)
    // }
    resetFilter({ state, commit, dispatch }, type) {
      commit("resetFilter", type);
      switch (type) {
        case "manufacturers":
          dispatch("getManufacturerData");
          dispatch("setQueryParams", { nameQuery: type, arr: [] });
          break;
        case "files":
          dispatch("getFilesData");
          dispatch("setQueryParams", { nameQuery: type, arr: [] });
          break;
        case "materials":
          dispatch("getMaterialsData");
          dispatch("setQueryParams", { nameQuery: type, arr: [] });
          break;
        case "objects":
          dispatch("getObjectsTypesData");
          dispatch("setQueryParams", { nameQuery: type, arr: [] });
          break;
        case "aparts":
          dispatch("getApartsData");
          dispatch("setQueryParams", { nameQuery: type, arr: [] });
          break;
        case "preview":
          dispatch("setQueryParams", { nameQuery: "view3d", arr: [] });
          dispatch("setQueryParams", { nameQuery: "viewAr", arr: [] });
          break;
        case "category":
          state.data.types = [];
          state.data.classes = [];
          dispatch("setQueryParams", { nameQuery: "category", arr: [] });
          dispatch("setQueryParams", { nameQuery: "type", arr: [] });
          dispatch("setQueryParams", { nameQuery: "class", arr: [] });

          break;
        case "all":
        default:
          dispatch("resetQueryParams");
          dispatch("getFirstData");
          state.data.types = [];
          state.data.classes = [];
          dispatch("renderModels");
          break;
      }
      dispatch("checkQueryParams");
    },

    counterFilterTags({ commit }, amount) {
      commit("counterFilterTags", amount);
    },

    // сформировать список параметров для запроса моделей
    // используется в ./pages/models/index.vue
    async formModelsQueryParams({ state }, group = false) {
      const data = new URLSearchParams();
      //количество запрашиваемых моделей
      let countModels = state.filter.countModels;

      if (!countModels) {
        countModels = "48";

        if (window.innerWidth > 959 && window.innerWidth < 1279) {
          countModels = "40";
        }
      }

      data.append("limit", countModels);

      // сортировка
      if (state.filter.sort) data.append("sort", state.filter.sort);

      // запрос отображения конкретной страницы
      data.append("page", state.filter.page);
      data.append("offset", (state.filter.page - 1) * countModels || 0);

      //выбор производителей
      if (state.filter.manufacturers.length)
        data.append("company_uuid", state.filter.manufacturers);

      //выбор файлов
      if (state.filter.files) data.append("files_ext", state.filter.files);

      //выбор категорий
      if (state.filter.categories) data.append("code_category", state.filter.categories);

      if (state.filter.types) {
        data.append("code_type", state.filter.types);
      }
      if (state.filter.classes) {
        data.append("code_class", state.filter.classes);
      }
      if (state.filter.attributes) {
        data.append("attributes", state.filter.attributes);
      }

      //выбор объектов
      if (state.filter.objects.length) data.append("code_building", state.filter.objects);

      //выбор помещения
      if (state.filter.aparts.length) data.append("code_room", state.filter.aparts);

      //выбор материалов
      if (state.filter.materials.length) data.append("code_material", state.filter.materials);

      if (state.filter.view3d) {
        data.append("models3D", state.filter.view3d);
        data.append("is_viewer3d", state.filter.view3d);
      }

      if (state.filter.viewAr) {
        data.append("armodels", state.filter.viewAr);
        data.append("is_iphone_viewer3d", state.filter.viewAr);
      }

      // Поиск
      data.append("name", state.filter.search);

      // поля
      if (group) {
        data.append("list_fields", "id,name,name_short,images,company_uuid," + "group_company");
      } else {
        data.append("list_fields", "id,name,name_short,images,company_uuid");
      }

      return new Promise((resolve) => resolve(data));
    },

    async renderModels({ state, commit, dispatch }) {
      dispatch("loader", true);
      // if (state.firstOnload) state.firstOnload = false

      try {
        const params = await dispatch("formModelsQueryParams", true);
        const response = await axios.post("/web-api-2/model/searchmodels/", params)

        let models = response.data.models;
        const group = response.data.group;
        // models.push(...response.data.Result.Grid.data)

        if (!models.length) {
          commit("getTotalPages", 0);
          commit("getTotalModels", 0);
          commit("getTotalAllModels", response.data.total_all);
        } else {
          commit("getTotalPages", response.data.totalPages);
          commit("getTotalModels", response.data.total);
          commit("getTotalAllModels", response.data.total_all);
        }
        commit("getModels", models); // отправляем модели в хранилище
        commit("setGroupedModels", group); // сгруппированные модели по компаниям
        commit("contentLoaded"); // переключаем флаг что контент загружен

        return models;
      } catch (error) {
        console.error(error)
      } finally {
        dispatch("loader", false)
      }

      return null
    },
  },
  getters: {
    manufacturersData: (state) => state.data.manufacturers,
    manufacturersDataPaidTariff: (state) => state.data.manufacturers.filter((itm)=>{
      return itm.tariff[0] && itm.tariff[0].tariff_plan_id !== '553af5f8-a90e-4d73-b204-72f601b83247'
    }), // Производители с тарифами !== бесплатный
    filesData: (state) => state.data.files,
    objectsData: (state) => state.data.objects,
    apartsData: (state) => state.data.aparts,
    materialsData: (state) => state.data.materials,
    categoriesData: (state) => state.data.categories,
    typesData: (state) => state.data.types,
    classesData: (state) => state.data.classes,
    modelsData: (state) => state.data.models,
    groupedModels: (state) => state.data.group,

    sortFilter: (state) => state.filter.sort,
    categoriesFilter: (state) => state.filter.categories,
    typesFilter: (state) => state.filter.types,
    classesFilter: (state) => state.filter.classes,
    regionsFilter: (state) => state.filter.regions,
    view3dFilter: (state) => state.filter.view3d,
    viewArFilter: (state) => state.filter.viewAr,
    searchFilter: (state) => state.filter.search,

    contentLoaded: (state) => state.contentLoaded,
    totalPages: (state) => state.totalPages,
    totalModels: (state) => state.totalModels,
    totalAllModels: (state) => state.totalAllModels,
    gridType: (state) => state.gridType,
    counterFilterTags: (state) => state.counterFilterTags,
    getLocationQuery: (state) => state.locationQuery,
    currentPage: (state) => state.filter.page,

    filter: (state) => state.filter,
  },
};
